import React, { useEffect, useState } from 'react'
import Layout from '../Layout';
import { Container, Box, Grid, Button, TextField, CircularProgress } from '@material-ui/core';
import DataTable from '../Table';
import { useDispatch, useSelector } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import GetAppIcon from '@material-ui/icons/GetApp';
import SearchIcon from '@material-ui/icons/Search';
import RefreshIcon from '@material-ui/icons/Refresh';
import Select from 'react-select';
import 'react-toastify/dist/ReactToastify.css';
import { getBreakdownLogs } from '../../ReduxStore/Breakdown/BreakdownSlice';
import CustomBreadcrumbs from '../Breadcrumb';
import { GridLoadingSpinner } from '@tmlconnected/avant-garde-components-library';
import { convertUTCtoIST } from '../../helpers/DateConvert';
import * as XLSX from 'xlsx';
import { getAssetwithVendorCode, getVendorData } from '../../ReduxStore/VendorDataSlice';
import { getMasterTableData } from '../../ReduxStore/MastertableSlice';
import { formatDateTime, customStyles } from '../../helpers/DateConvert';


const columns = [
    { id: 'Sr.no', label: 'Sr.no', minWidth: 50 },
    { id: 'machine_details.asset_no', label: 'Asset', minWidth: 80 },
    { id: 'machine_details.asset_text', label: 'Description', minWidth: 150 },
    { id: 'name', label: 'Title', minWidth: 80 },
    { id: 'priority', label: 'Priority', minWidth: 100 },
    { id: 'status', label: 'Status', minWidth: 100 },
    { id: 'reason.name', label: 'Breakdown Reason', minWidth: 120 },
    { id: 'reported_by', label: 'Reported by', minWidth: 150 },
    { id: 'reported_at', label: 'Reported at', minWidth: 120 },
    { id: 'attended_by', label: 'Attended by', minWidth: 150 },
    { id: 'attended_at', label: 'Attended at', minWidth: 150 },
    { id: 'resolved_by', label: 'Resolved by', minWidth: 150 },
    { id: 'approved_by', label: 'Approved by', minWidth: 140 },
    { id: 'approved_at', label: 'Approved at', minWidth: 120 }
];

const BreakdownLogs = () => {
    const dispatch = useDispatch();
    const breadcrumbsLinks = [
        { label: 'Home', href: '/' },
        { label: 'Breakdown Management', href: '/breakdown-management' },
    ];

    const [loading, setLoading] = useState(true);
    const [searchLoading, setSearchLoading] = useState(false);
    const [resestLoading, setResetLoading] = useState(false);
    const [BDLogs, setBDLogs] = useState([]);
    const Role = localStorage.getItem("userRole");
    const [masterData, setMasterData] = useState([]);
    const { response } = useSelector(state => state.vendor);
    const [AssetOptions, setAssetOptions] = useState([]);
    const [SupplierOptions, setSupplierOptions] = useState(null);
    const [selectedSupplier, setselectedSupplier] = useState(null);
    const [selectedAsset, setselectedAsset] = useState(null);

    const [formData, setFormData] = useState({
        startDate: '',
        endDate: ''
    });
    const [filteredLogs, setFilteredLogs] = useState(BDLogs);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const searchHandler = async () => {
        if (!formData.startDate) {
            toast.warn("Please select the Start Date first!")
            return
        }
        setSearchLoading(true)
        await getDBlogs(`?status_id=all&start=0&limit=20&from_time=${formatDateTime(formData.startDate)}&to_time=${formatDateTime(formData.endDate)}`)
        setSearchLoading(false)

    }

    const resetHandler = async () => {
        setResetLoading(true)
        setFormData({ startDate: '', endDate: '' });
        await getDBlogs('?status_id=all&start=0&limit=20'); // Refresh logs without filters
        setResetLoading(false)
    };


    const getDBlogs = async (param) => {
        try {
            const action = dispatch(getBreakdownLogs(param));
            const res = await action.unwrap();
            console.log("res", res.result)
            if (res.result) {
                // Process the data to remove the first 3 letters from asset_no if it exists
                const modifiedData = res.result.breakdowns.map(item => ({
                    ...item,
                    machine_details: {
                        ...item.machine_details,
                        asset_no: item.machine_details?.asset_no ? item.machine_details.asset_no.slice(3) : item.machine_details.asset_no
                    }
                }));

                const mergedLogs = modifiedData.map(log => {
                    return {
                        ...log,
                        reported_at: convertUTCtoIST(log.reported_at),
                        attended_at: convertUTCtoIST(log.attended_at),
                        resolved_at: convertUTCtoIST(log.resolved_at),
                        approved_at: convertUTCtoIST(log.approved_at)
                    }

                });

                setBDLogs(mergedLogs)
            };
        } catch (error) {
            console.error("Error in okHandler:", error);
            toast.error(error.message || "No Logs Found!");
        }
    }

    const assetDataforVendor = async () => {
        try {
            // setLoading(true)
            const action = dispatch(getAssetwithVendorCode());
            const res = await action.unwrap();
            if (res.result) {
                setLoading(false)
                setMasterData(res.result)
            };
        } catch (error) {
            toast.error(error.message || "Asset Not Found!");
        } finally {
            // setLoading(false)
        }
    }

    const getAssetDataforVendor = async (vendor_code) => {
        try {
            // setLoading(true)
            const action = dispatch(getMasterTableData({ page: 1, limit: 500, queryParams: `vendor_code=${vendor_code}` }));
            const res = await action.unwrap();
            console.log("ALL DATA", res.result.data)
            if (res.result.data) {
                setLoading(false)
                if (res.result.data.length > 0) {
                    setMasterData(res.result.data)
                } else {
                    toast.info("Asset Not Found!")
                }
            };
        } catch (error) {
            console.error("Error in okHandler:", error);
            toast.error(error.message || "Asset Not Found!");
        } finally {
            // setLoading(false)
        }
    }

    const exportToExcel = () => {
        // Create a new worksheet from the data
        const worksheet = XLSX.utils.json_to_sheet(BDLogs);

        // Create a new workbook and append the worksheet
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

        // Generate a buffer and trigger the download
        XLSX.writeFile(workbook, 'BD_Logs.xlsx');
    };

    useEffect(() => {
        if (selectedSupplier) {
            getAssetDataforVendor(selectedSupplier.value);
        }

    }, [selectedSupplier])

    // Filter logs based on selected supplier
    useEffect(() => {
        if (selectedSupplier) {
            const vendorName = selectedSupplier.label.split('(')[0].trim();
            console.log("Vendor Name for filtering:", vendorName);

            const filtered = BDLogs.filter(
                (log) => log.machine_details.vendor_name === vendorName
            );
            console.log("In filtering:======", filtered);
            setFilteredLogs(filtered);
        } else {
            setFilteredLogs(BDLogs);
        }

    }, [selectedSupplier, BDLogs]);

    // Filter logs based on selected asset
    useEffect(() => {
        if (selectedAsset) {
            const assetNo = selectedAsset.value.replace(/^PVP/, '').trim(); // Remove 'PVP' prefix
            // console.log("Normalized Asset Number for filtering:", assetNo);
            // BDLogs.forEach((log, index) => {
            //     console.log(
            //         `Log ${index}:`,
            //         log.machine_details.asset_no,
            //         typeof log.machine_details.asset_no
            //     );
            // });

            const filtered = BDLogs.filter(
                (log) => log.machine_details.asset_no === assetNo
            );
            setFilteredLogs(filtered);
        } else {
            setFilteredLogs(BDLogs);
        }

    }, [selectedAsset, BDLogs]);

    useEffect(() => {
        const Supplierlist = response && response.map(item => ({
            label: `${item.vendor_group} (${item.vendor})`,
            value: item.vendor
        }));

        if (Supplierlist) {
            setSupplierOptions(Supplierlist.map((item, index) => ({
                value: item.value,
                label: item.label
            })));
        }

        const Assetlist = masterData && masterData.map(item => ({
            value: item.asset_no || item.Asset_no,
            // label: item.Asset_description || item['Asset description'],
            label: `${(item.asset_no)?.slice(3) || (item.Asset_no?.slice(3))} - ${item['Asset description'] || item.Asset_description}`,
            // label: `${item.asset_no} - ${item['Asset description'] || item.Asset_description}`,
        }));

        if (Assetlist) {
            setAssetOptions(Assetlist.map(item => ({
                value: item.value,
                label: item.label,
            })));
        }
    }, [masterData, response]);

    useEffect(() => {
        const fetchData = async () => {
            await getDBlogs('?status_id=all&start=0&limit=20');
            setLoading(false);
        };
        fetchData();
        if (Role === "admin") {
            dispatch(getVendorData());
        } else {
            // dispatch(getAssetwithVendorCode());
            assetDataforVendor();
        }
    }, [])


    if (loading) {
        return (
            <Layout>
                <Container>
                    <Box mt={4} display="flex" justifyContent="center" alignItems="center" minHeight="80vh" >
                        <GridLoadingSpinner />
                    </Box>
                </Container>
            </Layout>
        );
    }

    return (
        <Layout>
            <Container>
                <Box mt={1} mb={2}>
                    <CustomBreadcrumbs links={breadcrumbsLinks} current="Breakdown Logs" />
                </Box>
                <Box mt={3} mb={2}>
                    <Grid container spacing={1}>
                        {Role === "admin" && <Grid item xs={12} sm={2}>
                            <Select
                                styles={customStyles}
                                options={SupplierOptions}
                                placeholder="Select Vendor"
                                isSearchable
                                onChange={setselectedSupplier}
                                isClearable
                                menuPlacement="auto"
                            />
                        </Grid>}
                        <Grid item xs={12} sm={Role === "admin" ? 2 : 3}>
                            <Select
                                styles={customStyles}
                                options={AssetOptions}
                                placeholder="Select Asset"
                                isSearchable
                                isClearable
                                onChange={setselectedAsset}
                                menuPlacement="auto"
                                required
                            />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <TextField
                                label="From"
                                name="startDate"
                                type="date"
                                variant="outlined"
                                fullWidth
                                size='small'
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={formData.startDate}
                                onChange={handleInputChange}
                            />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <TextField
                                label="To"
                                name="endDate"
                                type="date"
                                variant="outlined"
                                fullWidth
                                size='small'
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={formData.endDate}
                                onChange={handleInputChange}
                            />
                        </Grid>
                        <Grid item xs={12} sm={1}>
                            <Button
                                variant="contained"
                                color="primary"
                                className="customButton"
                                fullWidth
                                onClick={searchHandler}
                                // endIcon={searchLoading ? <CircularProgress size={20} /> : <SearchIcon />}
                                endIcon={
                                    searchLoading ? (
                                        <CircularProgress
                                            size={24} // Match the SearchIcon size
                                            style={{ color: 'white' }} // Make CircularProgress white
                                        />
                                    ) : (
                                        <SearchIcon fontSize="medium" /> // Adjust size as needed
                                    )
                                }
                            // endIcon={<SearchIcon />}
                            >
                                Search
                            </Button>
                        </Grid>
                        <Grid item xs={12} sm={1}>
                            <Button
                                variant="contained"
                                color="secondary"
                                className="customButton"
                                fullWidth
                                onClick={resetHandler}
                                // endIcon={<RefreshIcon />}
                                endIcon={
                                    resestLoading ? (
                                        <CircularProgress
                                            size={16} // Match the SearchIcon size
                                            style={{ color: 'white' }} // Make CircularProgress white
                                        />
                                    ) : (
                                        <RefreshIcon fontSize="medium" /> // Adjust size as needed
                                    )
                                }
                            >
                                Reset
                            </Button>
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <Button
                                variant="contained"
                                color="primary"
                                className="customButton"
                                fullWidth
                                onClick={exportToExcel}
                                endIcon={<GetAppIcon />}
                            >
                                Export to Excel
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
                <Box mb={2}>
                    <Grid container>
                        <Grid item xs={12}>
                            <DataTable data={filteredLogs} columns={columns} />
                        </Grid>
                    </Grid>
                </Box>
            </Container>
            <ToastContainer />
        </Layout>
    )
}

export default BreakdownLogs